import React, { FC } from 'react'
import { Icon } from '@ui-kitten/components'
import { BtText } from './BtText'
import { useTranslation } from 'react-i18next'

interface Props {
  height?: number
}

export const BtEncryptedAndSecuredBadge: FC<Props> = ({ height = 52 }) => {
  const { t } = useTranslation('global')

  return (
    <div
      style={{
        height,
        borderRadius: 12,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(270deg, #003C6C 0%, #00A0F3 100%)`,
      }}
    >
      <Icon
        fill="white"
        name="shield-outline"
        style={{ width: 20, marginRight: 5 }}
      />
      <BtText color="white" weight="700" size={16}>
        {t('BtEncryptedAndSecuredBadge.Text')}
      </BtText>
    </div>
  )
}
